import cx from 'classnames';
import { useMeQuery, UserRole } from 'legoland-sdk/dist/experimental';
import { useEffectiveLimitsQuery } from "../api/limitsApiHooks";
import { useProductLimitSchemas } from "../productsHooks";
import { useEffect, useState } from 'react';
import { Button, Text, useTombac } from 'tombac';
import { DeleteIcon, EditIcon } from 'tombac-icons';
import { useUserDetails } from "../../users/UserDetailsProvider";
import DeleteLimitsModal from "./DeleteLimitsModal";
import LimitsModal from "./LimitsModal";
import "./LimitsSummary.css";
import { LimitSummaryList } from "./LimitSummaryList";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function LimitsSummary(_ref) {
  let {
    className,
    headerClassName,
    isEditOpen = false,
    onRequestEditClose,
    onRequestEditOpen,
    product,
    readOnly
  } = _ref;
  const tombac = useTombac();
  const me = useMeQuery().data.me;
  const schemas = useProductLimitSchemas({
    productId: product.id
  });
  const [trashModalOpen, setTrashModalOpen] = useState(false);
  const user = useUserDetails();
  const [limits, setLimits] = useState(null);
  const effectiveLimitsQuery = useEffectiveLimitsQuery({
    username: user.email,
    productId: product.id
  });
  const {
    limits: loadedLimits,
    sharedWith,
    usage: limitsUsage
  } = effectiveLimitsQuery.data?.result ?? {};
  useEffect(() => {
    let limits = null;
    if (loadedLimits && schemas) {
      limits = {};
      schemas.forEach(_ref2 => {
        let {
          customizable,
          name,
          type
        } = _ref2;
        if (type !== 'BOOLEAN' && name in loadedLimits && customizable && loadedLimits[name] !== undefined && loadedLimits[name] !== null && (me.role !== UserRole.Admin || !sharedWith.find(i => i.names.includes(name)))) limits[name] = loadedLimits[name];
      });
    }
    setLimits(limits);
  }, [loadedLimits, me, schemas, sharedWith]);
  const handleEditClose = () => {
    onRequestEditClose();
    effectiveLimitsQuery.refetch();
  };
  const handleTrashClose = () => {
    setTrashModalOpen(false);
    effectiveLimitsQuery.refetch();
  };
  const limitsExist = limits && Object.values(limits).length > 0;
  return schemas && schemas.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: cx('LimitsSummary__header', headerClassName),
      children: "Usage limits"
    }), /*#__PURE__*/_jsxs("div", {
      className: cx('LimitsSummary', className),
      children: [effectiveLimitsQuery.isLoading ? /*#__PURE__*/_jsx(Text, {
        variant: "secondary",
        children: "Loading..."
      }) : effectiveLimitsQuery.isError ? /*#__PURE__*/_jsx(Text, {
        variant: "danger",
        children: "Error: Could not load data."
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LimitSummaryList, {
          $flex: "1",
          limits: limits,
          schemas: schemas,
          usages: limitsUsage
        }), !readOnly && /*#__PURE__*/_jsxs("div", {
          className: "LimitsSummary__toolbar",
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: () => onRequestEditOpen(),
            shape: "circle",
            size: "xs",
            variant: "flat",
            children: /*#__PURE__*/_jsx(EditIcon, {})
          }), limitsExist && /*#__PURE__*/_jsx(Button, {
            $ml: "0.5sp",
            onClick: () => setTrashModalOpen(true),
            shape: "circle",
            size: "xs",
            variant: "flat",
            children: /*#__PURE__*/_jsx(DeleteIcon, {
              color: tombac.color('danger')
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(LimitsModal, {
        configurator: {
          onRequestClose: handleEditClose,
          product
        },
        isOpen: isEditOpen
      }), /*#__PURE__*/_jsx(DeleteLimitsModal, {
        isOpen: trashModalOpen,
        onRequestClose: handleTrashClose,
        product: product
      })]
    })]
  }) : null;
}